import React from 'react';
import { convertNodeToElement } from 'react-html-parser';
import { DomElement } from 'htmlparser2';

import Link from '../components/link/link';

// finds the text in any children under an anchor tag
// removes all children tags as well as we don't want
// extra tags within link
const findText = (children: DomElement[]): string | null => {
  return children.reduce((text, child) => {
    if (child.children) {
      return findText(child.children);
    }
    return child.data;
  }, null);
};

const linkParser = (node: DomElement) => {
  if (node.type === 'tag' && node.name === 'p') {
    if (
      node.children?.some(child => child.type === 'tag' && child.name === 'a')
    ) {
      node.children.forEach((child, index: number) => {
        if (child.type === 'tag' && child.name === 'a') {
          if (child.attribs?.href?.includes('/documents/editNewOrRegister/')) {
            child.attribs.rel = 'nofollow';
          }
          convertNodeToElement(node, index, linkParser);
        }
      });
    }
  } else if (node.type === 'tag' && node.name === 'a' && node.parent) {
    if (
      node.children?.some(child => child.type === 'tag' && child.name === 'img')
    ) {
      return undefined;
    }
    if (node.attribs?.href && node.children?.length) {
      const text = findText(node.children);
      if (!text) {
        return null;
      }

      const { style, href, ...rest } = node.attribs;

      return (
        <Link
          {...rest}
          secondary
          underline="hover"
          to={href}
          excludeFromGatsby={node.data?.excludeFromGatsby}
        >
          {text}
        </Link>
      );
    }
  }
  return undefined;
};

export default linkParser;
